// import { Modes } from "./Constants";

// const isRxAdmin = (mode) => mode === Modes.private;

// const isParticipantBase = (mode) => mode === Modes.mixed;

// const captureResponseCodeAsError = (graphqlResponse, errorTranslations) => {
//   return graphqlResponse.errors.map((err) =>
//     Object.prototype.hasOwnProperty.call(errorTranslations, err.extensions.code)
//       ? errorTranslations[err.extensions.code]
//       : errorTranslations["server_error"]
//   );
// };

// const isHttpsUrlValid = (url) => {
//   try {
//     const urlType = new URL(url);
//     return urlType.protocol === "https:";
//   } catch (_) {
//     return false;
//   }
// };

// const isEmptyOrWhitespaces = (str) => str == null || str.trim() === "";

// const Utils = {
//   isRxAdmin,
//   isParticipantBase,
//   captureResponseCodeAsError,
//   isHttpsUrlValid,
//   isEmptyOrWhitespaces,
// };

export function fakeRandomProgress(
  fakeProgress,
  setFakeProgress,
  trueProgress,
  setTrueProgress
) {
  var newProgress = 0;
  const maxProgress = 95;
  const diff = 5;
  const limit = 20;
  // if (fakeProgress === 100) {
  //   setIsFull(true);
  // } else
  if (fakeProgress > trueProgress) {
    newProgress = fakeProgress;
  } else if (fakeProgress + limit < trueProgress) {
    newProgress = trueProgress;
  } else newProgress = fakeProgress + Math.random() * 10;
  setFakeProgress(Math.min(newProgress, maxProgress));
  setTrueProgress(Math.min(trueProgress + diff, maxProgress));
  //console.log(trueProgress);
}

export async function waitWithProb(fakeResponseTime, prob = 0.9) {
  await new Promise((resolve) => setTimeout(resolve, fakeResponseTime));
  const response = Math.random() < prob;
  //console.log("Fake response result:" + response);
  return response;
}

//export default Utils;
